import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isSidebarExpanded: boolean;
  }>()
  .create(({ theme, isSidebarExpanded }) => ({
    submenuButton: {
      display: 'block',
      borderTop: `1px solid rgba(255, 255, 255, 0.10)`,
      marginTop: theme.spacing(3),
      '& .MuiListItem-root': {
        display: 'block'
      }
    },
    submenuButtonButton: {
      display: 'flex',
      height: theme.spacing(6.5),
      justifyContent: isSidebarExpanded ? 'space-between' : 'center',
      padding: isSidebarExpanded ? theme.spacing(1, 3, 1, 3) : theme.spacing(0),
      position: 'relative',
      '& div:nth-of-type(1)': {
        display: 'flex'
      },
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.10)'
      },
      '&.active': {
        backgroundColor: 'rgba(255, 255, 255, 0.10)',
        svg: {
          opacity: 1
        }
      },
      svg: {
        opacity: 0.5
      }
    },
    submenuButtonIcon: {
      alignItems: 'center',
      display: 'flex',
      color: 'rgba(255, 255, 255, 0.70)',
      fontSize: isSidebarExpanded ? '1.25rem' : '1.75rem',
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: 'normal',
      justifyContent: 'center',
      minWidth: isSidebarExpanded ? theme.spacing(4) : 0,
      width: isSidebarExpanded ? 'auto' : '100%',
      '.svg-inline--fa': {
        fontSize: isSidebarExpanded ? '1.25rem' : '1.5rem !important'
      }
    },
    submenuButtonSubmenuIcon: {
      color: 'rgba(255, 255, 255, 0.60)',
      display: isSidebarExpanded ? 'block' : 'none',
      marginRight: theme.spacing(1)
    },
    submenuButtonText: {
      '& > .MuiTypography-root': {
        color: 'rgba(255, 255, 255, 0.60)',
        display: isSidebarExpanded ? 'block' : 'none',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        marginLeft: theme.spacing(0.5),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap'
      }
    }
  }));

export default useStyles;
